import {
  BBScene,
  BBCamera,
  BBSphere,
  BBBox,
  BBCylinder,
  BBPlane,
  BBSky,
  BBGround,
  BBLight,
} from './core';

customElements.define('bb-scene', BBScene);
customElements.define('bb-camera', BBCamera);
customElements.define('bb-sphere', BBSphere);
customElements.define('bb-box', BBBox);
customElements.define('bb-cylinder', BBCylinder);
customElements.define('bb-plane', BBPlane);
customElements.define('bb-ground', BBGround);
customElements.define('bb-sky', BBSky);
customElements.define('bb-light', BBLight);
